import React from 'react';
import { BrowserRouter as Router, Routes, Link, Route } from 'react-router-dom';
import logo from './logo.svg';
import './App.css';







import Home from './Pages/Home';
import About from './Pages/About';
import PrivacyNotice from './Pages/Privacy_Notice';
import Partners from './Pages/Partners';
import Contact from './Pages/Contact';
import GuestPolicy from './Pages/Guest-Policy';
import TrustSafety from './Pages/Trust-Safety';
import Login from './Pages/Login';
import Signup from './Pages/Signup';
import UserForgetPass from './Pages/UserForgetPass';
import Partners_Join from './Pages/Partners_Join';
import PartnersTerm from './Pages/Partner-Term';
import PartnersPolicy from './Pages/Partner-Privacy';
import PartnersPromise from './Pages/Partner-Promise';
import SearchResults from './Pages/SearchResults';
import SinglePropertyDetail from './Pages/SinglePropertyDetail';
import Book from './Pages/Book';
import FinalStepBooking from './Pages/FinalStepBooking';
import ConfirmationBooking from './Pages/confirmation';


import HelpHome from "./Pages/HelpHome";
import HelpFaqs from "./Pages/HelpFaqs";
import HelpPayments from "./Pages/HelpPayments";
import HelpCancellations from "./Pages/HelpCancellations";
import HelpBookingDetails from "./Pages/HelpBookingDetails";
import HelpCommunications from "./Pages/HelpCommunications";
import HelpRoomTypes from "./Pages/HelpRoomTypes";
import HelpPricing from "./Pages/HelpPricing";
import HelpPolicies from "./Pages/HelpPolicies";
import HelpFacilities from "./Pages/HelpFacilities";
import HelpSecurity from "./Pages/HelpSecurity";
import HelpPrivacy from "./Pages/HelpPrivacy";
import HelpTrustSafety from "./Pages/HelpTrustSafety";
import HelpGuestPolicy from "./Pages/HelpGuestPolicy";


import Header from './Components/Header';
import Footer from './Components/Footer';
import HelpLayout from "./Components/HelpLayout";


import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import "./css/bootstrap.min.css"
import "./fonts/css/fontawesome.min.css"
import "./fonts/css/brands.min.css" 
import "./fonts/css/solid.min.css" 
import "./css/global.css"
import "./css/index.css"

  //  <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"></script>
	// <script src="js/bootstrap.bundle.min.js"></script>


function App() {
  return (
    <>
      <ToastContainer position="top-center" autoClose={2000} />

    <Router>

        <Header />
<Routes>

          <Route exact path='/' element={<Home/>} />
          <Route exact path='/searchresults' element={<SearchResults/>} />
          
          
          
          
          
          <Route exact path='/about' element={<About/>} />
          <Route exact path='/privacy-notice' element={<PrivacyNotice/>} />
          <Route exact path='/partner-with-us' element={<Partners/>} />
          <Route exact path='/contact' element={<Contact/>} />
          <Route exact path='/trust-safety' element={<TrustSafety/>} />
          <Route exact path='/guest-policy' element={<GuestPolicy/>} />
          
          
          
          
          <Route exact path='/login' element={<Login/>} />
          <Route exact path='/sign-up' element={<Signup/>} />



          <Route exact path='/forget-password' element={<UserForgetPass/>} />
          <Route exact path='/join-us-partners' element={<Partners_Join/>} />
          <Route exact path='/partners-term-condition' element={<PartnersTerm/>} />
          <Route exact path='/partners-privacy-policy' element={<PartnersPolicy/>} />
          <Route exact path='/partners-promise' element={<PartnersPromise/>} />





          <Route exact path='/property/:id' element={<SinglePropertyDetail/>} />
          <Route exact path='/book' element={<Book/>} />
          <Route exact path='/check-booking' element={<FinalStepBooking/>} />
          <Route exact path='/confirmation/:bookingId' element={<ConfirmationBooking/>} />
          



          <Route path="/help" element={<HelpLayout />}>
          <Route index element={<HelpHome />} />
          <Route path="FAQS" element={<HelpFaqs />} />
          <Route path="payments" element={<HelpPayments />} />
          <Route path="cancellations" element={<HelpCancellations />} />
          <Route path="booking-details" element={<HelpBookingDetails />} />
          <Route path="communications" element={<HelpCommunications />} />
          <Route path="room-types" element={<HelpRoomTypes />} />
          <Route path="pricing" element={<HelpPricing />} />
          <Route path="policies" element={<HelpPolicies />} />
          <Route path="facilities" element={<HelpFacilities />} />
          <Route path="security" element={<HelpSecurity />} />
          <Route path="privacy-policy" element={<HelpPrivacy />} />
          <Route path="trust-safety" element={<HelpTrustSafety />} />
          <Route path="guest-policy" element={<HelpGuestPolicy />} />
          </Route>



</Routes>
        <Footer />
      </Router>


    </>

  );
}

export default App;
